<template>
    <div>
        <CustomTreeSelect label="User Department" :optionsTree="departmentTree" @update:modelValue="onDepartmentSelected" />
    </div>
    <div v-if="departmentsSelected && departmentsSelected.length > 0">
        <div class="my-3">
            <h6>Selected Incidents:</h6>
            <div class="flex flex-wrap gap-2 department-chips-container">
                <DepartmentChips :departments-selected="departmentsSelected" @remove-department-selected="removeDepartmentSelected"></DepartmentChips>
            </div>
        </div>
    </div>

    <div v-if="loading === false">
        <div v-if="!departmentsSelected || departmentsSelected.length < 1" class="m-3">
            Saving the User without any departments means removing them from the User.
        </div>

        <Button  class="p-button-primary"  label="Submit" @click="confirmDepartmentsForUser" />
    </div>
    <div v-else class="m-3">
        <ScaleLoader />
    </div>
</template>

<script setup>

const emit = defineEmits(['close-department-user-dialog']);

import { onMounted, ref } from 'vue';
import { authStore, departmentStore } from '@/store/global-stores';
import { storeToRefs } from 'pinia';
import DepartmentChips from '@/modules/user/components/DepartmentChips.vue';
import { authApi } from '@/utilities/axios';

const { departmentTree, flatDepartments } = storeToRefs(departmentStore);

const props = defineProps({
    user: {
        type: Object,
        required: true
    },
})

const departmentsSelected = ref([]);
const loading = ref(false)

onMounted(async () => {
    loading.value = true;
    await departmentStore.fetchAllDepartments();
    departmentsSelected.value = await departmentStore.fetchUserDepartments(props.user.id);
    loading.value = false;
});

const removeDepartmentSelected = (selectedDepartment) => {
    departmentsSelected.value = departmentsSelected.value.filter(item => item.id !== selectedDepartment.id)
}

const onDepartmentSelected = (selectedDepartmentId) => {
    console.log('user', props.user)
    console.log('flatDepartments', flatDepartments)

    let selectedDepartment = null;

    if (flatDepartments && flatDepartments.value) {
        flatDepartments.value.forEach((department) => {
            if (department.id === selectedDepartmentId) {
                selectedDepartment = department;
            }
        })

        let found = false;

        // Check if the Department was already added to the list.
        departmentsSelected.value.forEach( (department) => {
            if (department.id === selectedDepartment.id) {
                found = true;
            }
        } )

        // Add it only if it's new.
        if (!found) {
            departmentsSelected.value.push(selectedDepartment)
            console.log('selectedDepartment', selectedDepartment)
        }
    }
}

const confirmDepartmentsForUser = async () => {
    // items selected: departmentsSelected

    loading.value = true

    //console.log('getLoggedUserCompanyId', authStore.getLoggedUserCompanyId)

    let url = process.env.VUE_APP_API_VERSION + '/admin/users/'+props.user.id+'/department?companyId='+authStore.getLoggedUserCompanyId;

    let departementList = [];
    departmentsSelected.value.forEach((department) => {
        departementList.push(department.id)
    })

    const response = await authApi.post(url, {
        departments: departementList,
    });
    if (response.statusCode === 200) {
        emit('close-department-user-dialog')
        loading.value = false
    } else {
        console.log('Error');
    }

};

</script>

<style scoped>
.department-chips-container {
    max-height: 10vh;
}
</style>
